// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul>li[data-v-241c2304]{margin-top:1rem;padding-right:3rem;padding-block:1rem;border:1px solid rgba(0,0,0,.5);border-radius:12px;list-style:none}", ""]);
// Exports
module.exports = exports;
